(function() {
    'use strict';

    angular
        .module('capacitacionCertificacionApp')
        .controller('CertificateDialogController', CertificateDialogController);

    CertificateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Certificate'];

    function CertificateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Certificate) {
        var vm = this;

        vm.certificate = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.certificate.id !== null) {
                Certificate.update(vm.certificate, onSaveSuccess, onSaveError);
            } else {
                Certificate.save(vm.certificate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('capacitacionCertificacionApp:certificateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
